import axios from 'axios';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  // baseURL:'http://192.168.137.1:8000/'
  baseURL: 'https://didysoft.net'
  // baseURL: 'https://mgnlotto.com'
  // baseURL: 'http://127.0.0.1:8000'
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
